import Highway from '@dogstudio/highway'
import modular from 'modujs'

import * as modules from './modules'
import AccordionBlock from './modules/AccordionBlock'
import Curtains from './modules/Curtains'
import CurtainsTransition from './modules/CurtainsTransition'
import Scroller from './modules/Scroller'
import { firstFireFoxCheck } from './utils/dom'
import { initPrefetch, refreshPrefetch } from './utils/prefetch'
import { handleAnchorScroll } from './utils/scroll'
import { classesInjection, rewriteLinks } from './utils/transitions'

const Modular = modular
const app = new Modular({
  modules
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted () {



    const accordionBlocks = document.querySelectorAll('.wp-block-accordion')
    accordionBlocks.forEach((accordionBlock) => {
      new AccordionBlock(accordionBlock)
    })

    handleAnchorScroll()
    rewriteLinks()
    refreshPrefetch()
    app.init(app)
    return this
  }

  onLeaveCompleted () {
    app.destroy()
    return this
  }
}

const init = () => {

  firstFireFoxCheck();
  classesInjection()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer
    },
    transitions: {
      default: CurtainsTransition
    }
  })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    app.destroy()
    window.lenis.start()
    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true
      })
    }
  })

  window.H = H

  new Scroller()
  new Curtains()
  initPrefetch()
}

document.addEventListener('DOMContentLoaded', init)
